export default "__VITE_ASSET__DrRz0UhF__"